import React , {Component} from 'react';
import * as axios from "axios/index";
import {
    Page  , Link
} from 'framework7-react';
import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import * as vars from './Vars';

import TrackingLoader from "../Loader/TrackingLoader";
class Tracking extends Component{


    onPageBeforeIn(){
        this.props.toolbar(false)
    }

    constructor(props){
        super(props)
        this.state = {
            requestLoading : true ,

            order : {
                address : '' ,
                id : 0 ,
                branchs_ID: "" ,
                branchs_title_fa: "",
                comment: "",
                date: "",
                error: 0,
                error_body: "",
                foods: [] ,
                pay_type: -1,
                pay_type_text: "",
                price_delivery: "",
                price_discount: "",
                price_gift: "",
                price_payable: "",
                price_real: "",
                price_tax: "",
                step: 0,
                step_text: "",
                time: "",
                time_u: "",
            } ,


        }
    }


    componentWillMount(){
        if (localStorage.getItem('logged') === undefined  || localStorage.getItem('logged') === null)
        {
            this.$f7router.navigate('/')
            return false
        }

        let data = new FormData()
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )
        data.append('orders_ID' ,this.props.f7route.params.orderId  )


        axios.post(vars.PreUrl + 'https://www.lavefood.com/v1/orders/details' , data )
            .then(response => {

                let data = response.data.result[0]
                if (data.error === 0)
                {
                    this.setState({
                        order : {
                            ...data ,
                            id : this.props.f7route.params.orderId
                        } ,
                        requestLoading : false ,
                    })

                }
                else{
                    this.$f7router.navigate('/')
                    return false
                }



            })
            .catch(error => {
                console.log(error)
            })
    }


    render(){


        const  object  = this.state.order


        let headerTitle = ""
        let headerDescription = ""
        let headerIcon = ""

        let step0Class = "step"
        let step101Class = "step"
        let step102Class = "step"
        let step103Class = "step"
        let step104Class = "step"


        if ( this.state.requestLoading === false)
        {

                 if (object.step === -1)
                 {
                     headerTitle = "در انتظار پرداخت"
                     headerDescription = "در انتظار پرداخت"
                     headerIcon = "https://www.lavefood.com/webappassets/images/step0.svg"

                     step0Class = "step"
                     step101Class = "step"
                     step102Class = "step"
                     step103Class = "step"
                     step104Class = "step"
                 }
                 else if (object.step === 0  )
                 {
                     headerTitle = "ثبت سفارش"
                     headerDescription = "سفارش شما ثبت شده و در انتظار رسیدگی توسط اپراتور رستوران است."
                     headerIcon = "https://www.lavefood.com/webappassets/images/step0.svg"

                     step0Class = "step doing"
                     step101Class = "step"
                     step102Class = "step"
                     step103Class = "step"
                     step104Class = "step"
                 }
                 else if ( object.step === 100 || object.step ===  101)
                 {
                     headerTitle = "در انتظار بررسی"
                     headerDescription = "سفارش شما ثبت شده و در انتظار رسیدگی توسط اپراتور رستوران است."
                     headerIcon = "https://www.lavefood.com/webappassets/images/step0.svg"

                     step0Class = "step done"
                     step101Class = "step doing"
                     step102Class = "step"
                     step103Class = "step"
                     step104Class = "step"

                 }

                 else if (object.step === 102 )
                 {
                     headerTitle = "در حال آماده‌سازی"
                     headerDescription = " سفارش شما در حال آماده سازی می باشد. پس از آماده شدن، به آدرس شما ارسال خواهد شد"
                     headerIcon = "https://www.lavefood.com/webappassets/images/step102.svg"

                     step0Class = "step done"
                     step101Class = "step done"
                     step102Class = "step doing"
                     step103Class = "step"
                     step104Class = "step"

                 }
                 else if (object.step === 103 || object.step === 301 ) {
                     headerTitle = "سفارش لغو شد"
                     headerDescription = "علت لغو : " + object.cancel_reason
                     headerIcon = "https://www.lavefood.com/webappassets/images/step103.svg"


                 }
                 else if (object.step === 104 )
                 {
                     headerTitle = "ارسال با پیک"
                     headerDescription = " سفارش شما توسط پیک برایتان ارسال شد و بزودی به شما تحویل .داده خواهد شد"
                     headerIcon = "https://www.lavefood.com/webappassets/images/step104.svg"

                      step0Class = "step done"
                      step101Class = "step done"
                      step102Class = "step done"
                      step103Class = "step"
                      step104Class = "step doing"

                 }
                 else if (object.step === 105 )
                 {
                     headerTitle = "تحویل داده شد"
                     headerDescription = "سفارش با موفقیت تحویل داده شد"
                     headerIcon = "https://www.lavefood.com/webappassets/images/step105.svg"

                      step0Class = "step done"
                      step101Class = "step done"
                      step102Class = "step done"
                      step103Class = "step"
                      step104Class = "step done"

                 }
        }




        return(
            <Page name="Tracking" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>

                <div id="inner-header"  className="bg-transparent" style={{ zIndex:"1000" , border:"none"}}>

                    <Link href="/" id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title" style={{ color:"#fff"}}>
                        وضعیت سفارش شما
                    </div>
                </div>



                {
                    this.state.requestLoading === true ? (
                        <TrackingLoader  />
                    ): (
                        <div id="tracking" className="bg-white h-100">
                            <div id="tracking-header">
                                <img className="cover" src="https://www.lavefood.com/webappassets/images/tracking-cover.jpg"/>
                                <div className="icon-container">
                                    <img className="icon" src={headerIcon}/>
                                </div>
                                <div className="title">
                                    {headerTitle}
                                </div>
                                <div className="description">
                                    {headerDescription}
                                </div>
                            </div>

                            <div id="tracking-step">
                                <div >

                                    <div className="b-row no-border" id="steps-container">

                                        <div className="b-col-3">

                                            <div className={step0Class}>
                                                <span className="bg-sp" />
                                                <i className="fas fa-check icon" />
                                                <div className="title">
                                                    ثبت‌
                                                </div>
                                            </div>

                                        </div>


                                        <div className="b-col-3">

                                            <div className={step101Class}>
                                                <i className="fas fa-check icon" />
                                                <div className="title">
                                                    بررسی
                                                </div>

                                            </div>

                                        </div>


                                        <div className="b-col-3">
                                            <div className={step102Class}>
                                                <i className="fas fa-check icon" />
                                                <div className="title">
                                                    آماده سازی
                                                </div>

                                            </div>

                                        </div>


                                        <div className="b-col-3">
                                            <div className={step104Class}>
                                                <i className="fas fa-check icon" />
                                                <div className="title">
                                                    ارسال
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>


                            <div id="order-details-content">
                                <div className="b-row no-gutters align-items-center">
                                    <div className="b-col-5">
                                        <div className="b-row no-gutters">
                                            <div className="b-col-6">
                                                <div className="title">
                                                    کد سفارش
                                                </div>
                                            </div>
                                            <div className="b-col-6">
                                                <div className="content">
                                                    {object.id}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="b-row no-gutters mt-2">
                                            <div className="b-col-6">
                                                <div className="title">
                                                    رستوران
                                                </div>
                                            </div>
                                            <div className="b-col-6">
                                                <div className="content">
                                                    {object.branchs_title_fa}
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="b-col-3" id="center-details">

                                        <div className="b-row no-gutters">
                                            <div className="b-col-12">
                                                <div className="content text-center">
                                                    {object.date}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="b-row no-gutters mt-2">
                                            <div className="b-col-12">
                                                <div className="content">
                                                    {object.time}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="b-col-4">

                                        <div className="b-row no-gutters">
                                            <div className="b-col-12">
                                                <div className="content content-2  text-center">
                                                    مشکلی وجود دارد؟
                                                </div>
                                            </div>
                                        </div>

                                        <div className="b-row no-gutters text-center mt-2">
                                            <div className="b-col-12">
                                                <div className="title">
                                                    <Link id="call-link">
                                                        <img src="https://www.lavefood.com/webappassets/images/call.svg" />
                                                        <span>تماس</span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div id="tracking-details-footer">
                                <Link href={`/order/${object.id}/`}   className="tracking-link">
                                    جزئیات سفارش
                                </Link>
                            </div>

                        </div>
                    )
                }

            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({

    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar ,
        branch : state.branch ,
    }
}

export default connect( mapStateToProps  , mapDispatchToProps)(Tracking);